module.exports = __webpack_public_path__ + "img/governate.197c485d.svg";